module.exports = __webpack_public_path__ + "static/moondog-78c6d6b9eafdd62cb71f38f94f7f0b27.jpg";